import React from 'react';
import './RenewalDetails.scss'
import { dateformatter } from "../../../utils/helpers";

/** @import {SectionMessageProps} from './SectionMessageTypes' */
function SectionMessage(/** @type {SectionMessageProps} */ props) {
    return (
        <div className={'sectionMessage'}>
            <div className={'content'}>
                <div className={'contentArea'}>
                    <div className={'iconText'}>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/f2d20270adf2c37adfa59a5694ac8c8d56e529b00f8b244f64528a5e7c0f913a?placeholderIfAbsent=true&apiKey=818a1763d6f1455a8e12b5148c04fc79"
                            className={'img'}
                            alt="Information icon"
                        />
                        <div className={'titleBody'}>
                            <span className={'titleText'}>
                                You'll receive our best available rate on
                            </span>
                            <span className={'highlightedText'}> {new Date(props.account.maturity ? props.account.maturity.maturityDate : '').toLocaleDateString('en-US', { weekday: 'long' })
                            } {dateformatter(props.account.maturity ? props.account.maturity.maturityDate : '')}</span>
                            <span className={'titleText'}>
                                , which might be our new customer rate or your renewal rate, depending on which one is higher. Renewal rates will never change, but the customer rates may go up or down.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SectionMessage;